import { createFileRoute, useParams } from "@tanstack/react-router";
import { RecordTypeAccessSection } from "./fullAccess";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/recordTypes/$recordTypeId/access",
)({
	component: OrgRecordTypeAccessTab,
});

function OrgRecordTypeAccessTab() {
	const { orgId } = useParams({
		from: "/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/recordTypes/$recordTypeId/access",
	});

	return (
		<div className="px-5 pb-5">
			<RecordTypeAccessSection orgId={orgId} />
		</div>
	);
}
